import React from 'react';

const ActionContainer = () => {
  return (
    <div className="text-right">
      <button
        type="submit"
        className="btnSizes filledBtn ml-5"
      >
        Post
      </button>
    </div>
  )
}

export default ActionContainer;